import { Pipe, PipeTransform } from "@angular/core";
import { ChatButtonInteraction } from "../models/chat-button-interaction";

@Pipe({name: 'toActionable', standalone: true, pure: true})
export class ToActionablePipe implements PipeTransform {
  transform(content: any): ChatButtonInteraction[] {
    if (Array.isArray(content?.followUpActions)) {
      return content.followUpActions.slice(0, 2); // Limit to 2 actions
    }
    return [];
  }
}
